<div class="accordion-section">
  <mat-accordion>
    <mat-expansion-panel
      *ngFor="let productionLine of productionLineService.productionLines()"
      (opened)="setSelection(productionLine.id!)"
      class="bg-qundis-grey-light"
    >
      <mat-expansion-panel-header class="bg-qundis-secundary-light">
        <mat-panel-title class="qundis-section-heading-h2">
          <i [class]="BootstrapIcon.productionLines" class="me-2"></i>
          {{ productionLine.name }} - {{ productionLine.shortcode }}
        </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="expansion-panel-content p-3">
          <div class="expansion-panel-description w-100 bg-white p-3 rounded-1">
            <h5>Produktionsbeschreibung</h5>
            <p>{{ productionLine.description }}</p>
          </div>
          <div
            class="pt-3 pb-5"
            *ngIf="
              navigationServive.activeComponent() !==
              'selectProductionLineComponent'
            "
          >
            <app-edit-delete-buttons
              [routeTo]="'line/' + productionLine.id"
              [itemToEdit]="'Produktionslinie'"
              [message]="
                'Soll die Produktionslinie inklusive aller Arbeitsplätze, Wissensdatenbankeinträge und Stillstandsmeldungen wirklich gelöscht werden?'
              "
              (editEvent)="
                productionLineService.productionLineBeingEdited$.next(
                  productionLine
                )
              "
              (deleteEvent)="
                productionLineService.delete$.next(productionLine.id!)
              "
            >
            </app-edit-delete-buttons>
          </div>
          <div class="workplaces-accordion-section">
            <p class="qundis-section-heading-h2">
              Untergeordnete Arbeitsplätze
            </p>
            <p>
              <mat-accordion multi class="inner-accordion">
                <mat-expansion-panel
                  *ngFor="
                    let workstation of workstationService.filteredWorkstations()
                  "
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title class="qundis-section-heading-h2">
                      {{ workstation.name }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <div
                      class="btn bg-qundis-primary-light w-100 text-start qundis-inner-content"
                      style="pointer-events: none"
                    >
                      <i [class]="BootstrapIcon.workstations"></i>
                      Status:
                      {{ workstation.is_active ? "AKTIV" : "INAKTIV" }}
                      <span
                        class="state-indicator"
                        [ngClass]="{
                          active: workstation.is_active,
                          inactive: !workstation.is_active
                        }"
                        >&#9679;</span
                      >
                    </div>
                    <div
                      class="workstation-details px-3 pt-4 qundis-inner-content"
                    >
                      <p>Arbeitsplatz Nummer: {{ workstation.position }}</p>
                      <p>
                        Arbeitsplatzbeschreibung: {{ workstation.description }}
                      </p>
                    </div>
                    <div
                      class="pt-3 pb-5"
                      *ngIf="
                        navigationServive.activeComponent() ===
                        'selectProductionLineComponent'
                      "
                    >
                      <app-edit-delete-buttons
                        [routeTo]="'workstation/' + workstation.id"
                        [itemToEdit]="'Arbeitsplatz'"
                        [message]="
                          'Soll der Arbeitsplatz inklusive aller Wissensdatenbankeinträge und Stillstandsmeldungen wirklich gelöscht werden?'
                        "
                        (editEvent)="
                          workstationService.workstationBeingEdited$.next(
                            workstation
                          )
                        "
                        (deleteEvent)="
                          deleteWorkstation(
                            workstation.id!,
                            workstation.position
                          )
                        "
                      >
                      </app-edit-delete-buttons>
                    </div>
                  </ng-template>
                </mat-expansion-panel>
              </mat-accordion>
              <button
                class="btn btn-qundis-primary qundis-btn-layer1 w-100 mt-4 d-flex justify-content-center align-items-center"
                [routerLink]="['/admin/workstations/workstation/new']"
                [queryParams]="{ formAction: 'create' }"
                (click)="setProductionLineBeingEdited(productionLine)"
              >
                <span class="me-2">Neuen Arbeitsplatz anlegen</span
                ><i [class]="BootstrapIcon.plus" class="fs-2"></i>
              </button>
            </p>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
  <button
    class="btn btn-qundis-warn qundis-btn-layer1 w-100 mt-5 d-flex justify-content-center align-items-center"
    *ngIf="
      navigationServive.activeComponent() !== 'selectProductionLineComponent'
    "
    [routerLink]="['inputForm']"
    [queryParams]="{ formAction: 'create' }"
  >
    <span class="me-2">Neue Produktionslinie anlegen</span>
    <i class="bi bi-plus fs-2"></i>
  </button>
</div>
